import React from 'react'
import { spacing } from '@mobi/component-library/Foundations'
import { Icon } from '@mobi/component-library/Legacy/Icon'
import { Flex } from '@mobi/component-library/Misc/Flex'
import type { KambiSportsEventDetails, KambiSportsSingleSelection } from '@mobi/betslip/types'
import { TeamsIcon } from '@mobi/sports-offering/Components/Common/TeamsIcon'
import { SelectionInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SelectionInfo'
import { SecondaryInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SecondaryInfo'
import { EventInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/EventInfo'
import { getSelectionNameFromKambiBetOffer } from '@core/Areas/Quickbet/helpers/selectionsKambi'

export const KambiSportsHeaderSingle: React.FC<{
  selection: KambiSportsSingleSelection
  eventDetails: KambiSportsEventDetails
}> = ({ selection, eventDetails }) => {
  const betOffer = selection.betOffer
  const sportName = eventDetails.events[0].sport
  const outcome = selection.betOffer.outcomes[0]

  return (
    <Flex flexDirection='column' gap={spacing.smx1}>
      <EventInfo
        icon={<Icon type='tab' size='2.2rem' />}
        eventInfo={eventDetails.events[0].englishName}
      />

      <SecondaryInfo
        marketInfo={betOffer.criterion.label}
        eventStart={eventDetails.events[0].start}
      />

      <SelectionInfo
        leftSlot={
          <div
            style={{
              width: '3rem',
              height: '3rem',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              borderRadius: '50%',
              background: '#47245D',
              flexShrink: 0,
            }}
          >
            <TeamsIcon
              betOfferType={betOffer.betOfferType.id}
              betOfferId={outcome.betOfferId}
              outcomeId={outcome.id}
              participantId={outcome.participantId}
              size='1.6rem'
              sportName={sportName}
            />
          </div>
        }
        text={getSelectionNameFromKambiBetOffer(betOffer)}
      />
    </Flex>
  )
}
